(() => {
  const init = (root) => {
    root.querySelectorAll('[data-story-photos]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const viewport = section.querySelector('.story-photos__viewport');
      const track = section.querySelector('.story-photos__track');
      const button = section.querySelector('button');
      const cards = Array.from(track.children);
      if (cards.length < 2) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches, visible = false, hover = false, focused = false, frame = 0, last = 0, position = 0;
      cards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-photo-clone', '');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('img').forEach((img) => { img.alt = ''; });
        track.appendChild(clone);
      });
      const cycle = () => track.children[cards.length].offsetLeft - cards[0].offsetLeft;
      const tick = (time) => {
        const distance = cycle();
        if (last && distance) {
          position = (position + Math.min(time - last, 50) * .025) % distance;
          viewport.scrollLeft = position;
        }
        last = time;
        frame = requestAnimationFrame(tick);
      };
      const update = () => {
        cancelAnimationFrame(frame); last = 0; position = viewport.scrollLeft;
        button.setAttribute('aria-pressed', String(paused));
        if (!paused && visible && !hover && !focused && !document.hidden) frame = requestAnimationFrame(tick);
      };
      button.hidden = false;
      button.addEventListener('click', () => { paused = !paused; update(); });
      viewport.addEventListener('mouseenter', () => { hover = true; update(); });
      viewport.addEventListener('mouseleave', () => { hover = false; update(); });
      viewport.addEventListener('focusin', () => { focused = true; update(); });
      viewport.addEventListener('focusout', () => { focused = false; update(); });
      viewport.addEventListener('pointerdown', () => { paused = true; update(); }, { passive: true });
      viewport.addEventListener('wheel', () => { paused = true; update(); }, { passive: true });
      reduced.addEventListener('change', () => { paused = reduced.matches; update(); });
      document.addEventListener('visibilitychange', update);
      const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); });
      observer.observe(section);
      update();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
